<template>
  <div class="side">
    <div class="ad">
      <a href="https://amzn.to/3NRtuhg" target="_blank" class="ad_link">
        <figure class="ad_figure">
          <img border="0" src="//ws-fe.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B010Q5QLRO&Format=_SL160_&ID=AsinImage&MarketPlace=JP&ServiceVersion=20070822&WS=1&tag=lotw-22&language=ja_JP" >
        </figure>
        <div class="ad_text">
          <div class="ad_text_lead">
            保持力がヤバい…！！
          </div>
          <div class="ad_text_title">東京粉末 ピュアブラック</div>
          <div class="ad_text_stars">
            <img src="/images/banner/stars45.svg">
          </div>
          <div class="ad_text_supplement">
            クライミング専用チョーク<br>
            amazon.co.jp
          </div>
        </div>
      </a>
    </div>
  </div>
</template>